import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgMiscSecurity = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      d="M3 2v2h16v6c0 4.81-1.97 7.76-7 10.38C6.97 17.76 5 14.81 5 10V6H3v4c0 7.46 4.63 10.43 9 12.62 4.38-2.19 9-5.16 9-12.62V2H3Z"
    />
    <path
      fill="#2D2E2E"
      d="m15.29 7.79-3.79 3.8-1.79-1.8-1.42 1.42 3.21 3.2 5.21-5.2-1.42-1.42Z"
    />
  </svg>
);
export default SvgMiscSecurity;
